import { getAsync, putAsync } from '../api.service'
import { AI_TOOLS_QUESTION_VERSION } from './question'

// A person's own AI tools sharing answer, on rapid-api-ai (called straight
// at REACT_APP_API_AI with the session, like the staff AI tools page; never
// through the gateway). Each resolves to the body;
// a refusal throws the response ({ status, data: { code, message } }), so
// serverMessage(err) reads the server's sentence and <ErrorReference
// error={err} /> its request id.
const base = () => process.env.REACT_APP_API_AI

// Whether this build knows where the ai service is.
export const consentAvailable = () => Boolean(base())

const unwrap = async call => {
  try {
    const result = await call()
    return result ? result.data : undefined
  } catch (err) {
    throw (err && err.response) || err
  }
}

// GET /consent, the tools' own read: { choice: 'share' | 'stopped' | null,
// questionVersion, answeredAt, minQuestionVersion, organizationAllows } (the
// signed-in organization's switch). Refused while impersonating (403
// ai_tools.impersonated).
export const getMyConsent = () => unwrap(() => getAsync(base(), 'api/ddd/ai-tools/consent'))

// PUT /consent with the question's choice and version alone. The tools also
// send their machine id, which tool and its version; all three are optional
// (contract §4.3, ruling P-R12) and the web has none of them, so the answer is
// stored without them. A stop unlinks what was already shared. Answers the GET's
// shape without organizationAllows; refused while impersonating, and limited to
// a few answers a minute (429 rate_limited).
export const putMyConsent = choice =>
  unwrap(() => putAsync(base(), 'api/ddd/ai-tools/consent', { choice, questionVersion: AI_TOOLS_QUESTION_VERSION }))

// What an answer means now: 'sharing' (a share of a question the server
// honours), 'not_sharing' (a stop), 'unanswered' (no answer, or a share of a
// question older than the server's minimum: the tools ask again).
export const consentState = consent => {
  if (!consent || !consent.choice) return 'unanswered'
  if (consent.choice === 'stopped') return 'not_sharing'
  const min = consent.minQuestionVersion || AI_TOOLS_QUESTION_VERSION
  return consent.choice === 'share' && (consent.questionVersion || 0) >= min ? 'sharing' : 'unanswered'
}
